<div style="margin: 10px 0px 10px 0px; padding: 10px 0px 10px 0px; width: 100%;">
  <mat-divider style="width: 100%;"></mat-divider>
</div>
